module.exports = __webpack_public_path__ + "img/about-patent3.330fc4f.png";